import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";

import "./permission";
import "@/aiUtils/utils/EventHub"
import "@/aiUtils/main"
import ElementUI from "element-ui";
import lkeComponent from 'lke-component';
import directives from "./directives";
import fetch, { UPLOAD_BASE_URL, BASE_URL,IS_DEV } from "@/utils/request";
import bus from "@/utils/bus";
import * as Filters from "@/utils/filter";
import * as tools from "@/utils/tools";

import MessageTip from "@/components/msgTips/index";
import ExcutePanel from "@/components/excutePanel/index";
import PImg from "@/components/pImg/Index.vue";
import EmptyHolder from "@/components/emptyHolder/Index.vue";

// import "element-ui/lib/theme-chalk/index.css";
import "@/style/index.scss";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(lkeComponent);
Vue.use(directives);
Vue.use(MessageTip);
Vue.use(ExcutePanel);
Vue.component("p-img", PImg);
Vue.component("empty-holder", EmptyHolder);

Vue.prototype.$bus  = bus;
Vue.prototype.$fetch = fetch;
Vue.prototype.$tools = tools;
Vue.prototype.$elsize = "small";
Vue.prototype.$tfmt = "yyyy/MM/DD HH:mm";
Vue.prototype.$dfmt = "yyyy/MM/DD";
Vue.prototype.$mfmt = "yyyy/MM";
Vue.prototype.$IS_DEV = IS_DEV;
Vue.prototype.$BASE_URL = BASE_URL;
Vue.prototype.$UPLOAD_BASE_URL = UPLOAD_BASE_URL;

Object.keys(Filters).forEach((key) => {
  Vue.filter(key, Filters[key]);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
